<div class='video-div'>
    <div class="close-button" (click)="onClose()">
        <span class="iconify" data-icon="mdi:close" data-inline="false" data-width="30" data-height="30"
            style="color:white"></span>
    </div>
    <div *ngIf="video.type && video.type === 'YOUTUBE'; else classicVideo">
        <iframe [src]="video.path | safeUrl" 
        title="YouTube video player" frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen></iframe>
    </div>
    <ng-template #classicVideo>
        <video id="my-video" class="video-js" controls preload="auto" autoplay="true" controlsList="nodownload">
            <source src="{{ video.path }}" type="video/mp4" />
            <p class="vjs-no-js">
                To view this video please enable JavaScript, and consider upgrading to a
                web browser that
                <a href="https://videojs.com/html5-video-support/" target="_blank">supports
                    HTML5
                    video</a>
            </p>
        </video>
    </ng-template>
</div>